import { render, staticRenderFns } from "./FaturasTeoricas.vue?vue&type=template&id=0be93f3f&scoped=true"
import script from "./FaturasTeoricas.vue?vue&type=script&lang=js"
export * from "./FaturasTeoricas.vue?vue&type=script&lang=js"
import style0 from "./FaturasTeoricas.vue?vue&type=style&index=0&id=0be93f3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be93f3f",
  null
  
)

export default component.exports